module.exports = __webpack_public_path__ + "img/Autocolant VVH_150mm x 180mm-01.b91c0b46.jpg";